__turbopack_context__.v({
  "carouselArrows": "scrollablechanneltiles-module-scss-module__jJkQ_W__carouselArrows",
  "carouselContainer": "scrollablechanneltiles-module-scss-module__jJkQ_W__carouselContainer",
  "carouselContainerOverlay": "scrollablechanneltiles-module-scss-module__jJkQ_W__carouselContainerOverlay",
  "gridContainer": "scrollablechanneltiles-module-scss-module__jJkQ_W__gridContainer",
  "lastSlideTile": "scrollablechanneltiles-module-scss-module__jJkQ_W__lastSlideTile",
  "leftArrow": "scrollablechanneltiles-module-scss-module__jJkQ_W__leftArrow",
  "rightArrow": "scrollablechanneltiles-module-scss-module__jJkQ_W__rightArrow",
  "slide": "scrollablechanneltiles-module-scss-module__jJkQ_W__slide",
  "slideTiles": "scrollablechanneltiles-module-scss-module__jJkQ_W__slideTiles",
  "splide": "scrollablechanneltiles-module-scss-module__jJkQ_W__splide",
  "viewMore": "scrollablechanneltiles-module-scss-module__jJkQ_W__viewMore",
});
